<template>
  <g-dropdown-wrap
    :value="value"
    class="custom-select -mr-2"
    @selected="onSelected"
    :open-item.sync="open">
    <template v-slot:selected="slotProps">
      <span
        class="-color-gray-1 -mx-0 -px-0 -font-size-12 -font-weight-medium -btn"
        @click="onClickOpen">
        <span>{{slotProps.selected.selectedText}}</span>
        <g-icon tag="span" :name="dropIcon"  width="16px" height="16px"></g-icon>
      </span>
    </template>
    <slot></slot>
  </g-dropdown-wrap>
</template>
<script>
export default {
  name: 'span-dropdown',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      open: false,
      selectedValue: this.value
    }
  },
  computed: {
    dropIcon () {
      return this.open ? 'arrow_drop_up' : 'arrow_drop_down'
    },
  },
  methods: {
    onClickOpen () {
      this.open = !this.open
    },
    onSelected (value, text) {

      this.selectedValue = value
      this.selectedText = text
      this.$emit('selected', {text,value})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/components/SpanDropdown.vue